import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

// import Profile from './Profile'

import EditIcon from '../../../Assets/icons/edit.svg'

import './ProfileView.css'


function ProfileView() {

    const { consumer } = useSelector(state => state.auth)
    return (
        <div className="profile_details_wrapper">
            <Link to='/edit-profile' className='btn_pedit'>
                {
                    consumer
                        ?
                        consumer.language === 'english'
                            ?
                            'Edit'
                            :
                            'এডিট'
                        :
                        'এডিট'
                }
                <img src={EditIcon} alt="edit icon" />
            </Link>
            <div className="profile_details">
                <div className="items">
                    <div className="item">
                        <h5>
                            {
                                consumer
                                    ?
                                    consumer.language === 'english'
                                        ?
                                        'Your Name'
                                        :
                                        'আপনার নাম'
                                    :
                                    'আপনার নাম'
                            }
                        </h5>
                        <p>{consumer.name}</p>
                    </div>
                    <div className="item">
                        <h5>
                        {
                                consumer
                                    ?
                                    consumer.language === 'english'
                                        ?
                                        'Your Email'
                                        :
                                        'আপনার ইমেইল'
                                    :
                                    'আপনার ইমেইল'
                            }
                            </h5>
                        <p>{consumer.email}</p>
                    </div>
                </div>
            </div>
        </div>


        // <section className="profile_view_page page_padding ss_page">
        //     <Profile />
        //     <div className="container">
        //         <div className="tabs_contents">
        //             <ul className="tabs_wrapper">
        //                 <li className="tab_item">
        //                     <Link to='/my-profile' className='active' onClick={(e) => e.preventDefault()} >আপনার প্রোফাইল</Link>
        //                 </li>
        //                 <li className="tab_item">
        //                     <Link to='/change-password'>পাসওয়ার্ড পরিবর্তন করুন</Link>
        //                 </li>
        //                 <li className="tab_item">
        //                     <Link to='/favorite'>পছন্দের তালিকা</Link>
        //                 </li>
        //             </ul>
        //             <div className="profile_details_wrapper">
        //                 <Link to='/edit-profile' className='btn_pedit'>
        //                     এডিট
        //                     <img src={EditIcon} alt="edit icon" />
        //                 </Link>
        //                 <div className="profile_details">
        //                     <div className="items">
        //                         <div className="item">
        //                             <h5>আপনার ফার্স্ট নেম</h5>
        //                             <p>মোশাররফ </p>
        //                         </div>
        //                         <div className="item">
        //                             <h5>আপনার লাস্ট নেম</h5>
        //                             <p>সানোয়ার</p>
        //                         </div>
        //                         <div className="item">
        //                             <h5>আপনার ফোন নাম্বার</h5>
        //                             <p>192059608034381</p>
        //                         </div>
        //                         <div className="item">
        //                             <h5>আপনার ইমেইল</h5>
        //                             <p>ali.pharahana@sekha.com</p>
        //                         </div>
        //                     </div>
        //                 </div>
        //             </div>
        //         </div>
        //     </div>
        // </section>
    )
}

export default ProfileView